var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23674 0.5C0.842256 0.5 0.522461 0.819796 0.522461 1.21429C0.522461 1.60877 0.842256 1.92857 1.23674 1.92857H1.81217L2.32242 5.33027L3.14949 10.8441C3.20193 11.1937 3.50229 11.4524 3.85586 11.4524H13.3796C13.7051 11.4524 13.9894 11.2323 14.0711 10.9172L15.4996 5.40346C15.555 5.1895 15.5084 4.96193 15.373 4.78714C15.2378 4.61234 15.0292 4.51003 14.8082 4.51003H3.64393L3.13368 1.10833C3.08123 0.758671 2.78087 0.5 2.4273 0.5H1.23674ZM4.47099 10.0238L3.85822 5.9386H13.8852L12.8269 10.0238H4.47099ZM7.18918 14.0714C7.18918 14.8604 6.54959 15.5 5.76062 15.5C4.97164 15.5 4.33205 14.8604 4.33205 14.0714C4.33205 13.2825 4.97164 12.6429 5.76062 12.6429C6.54959 12.6429 7.18918 13.2825 7.18918 14.0714ZM12.9034 14.0714C12.9034 14.8604 12.2638 15.5 11.4749 15.5C10.6859 15.5 10.0463 14.8604 10.0463 14.0714C10.0463 13.2825 10.6859 12.6429 11.4749 12.6429C12.2638 12.6429 12.9034 13.2825 12.9034 14.0714Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_icon.8d0cfad99253700a4cbbe5c576951f0f.svg";
export { ForwardRef as ReactComponent };